export default "__VITE_ASSET__5WBZfHPy__"